 (function() {
    class ProductCarousel extends HTMLElement {
      constructor() {
        super();
        this.currentSlide = 0;
        this.slidesPerView = this.dataset.desktopSlides;
        this.slidesPerViewMobile = this.dataset.mobileSlides;
      }

      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.slides = this.querySelectorAll('.product-highlight-carousel-slide');
        this.prevButton = this.querySelector('[data-prev]');
        this.nextButton = this.querySelector('[data-next]');
        this.indicatorsContainer = this.querySelector('[data-indicators]');

        if (this.slides.length === 0) return;

        this.setupCarousel();
        this.setupEventListeners();
        this.updateCarousel();
      }

      setupCarousel() {
        const totalSlides = this.slides.length;
        const currentSlidesPerView = window.innerWidth <= 768 ? this.slidesPerViewMobile : this.slidesPerView;
        const totalPages = Math.ceil(totalSlides / currentSlidesPerView);

        this.indicatorsContainer.innerHTML = '';
        for (let i = 0; i < totalPages; i++) {
          const indicator = document.createElement('button');
          indicator.className = 'product-highlight-carousel-indicator';
          indicator.setAttribute('data-slide', i);
          indicator.setAttribute('aria-label', `Go to slide ${i + 1}`);
          if (i === 0) indicator.classList.add('active');
          this.indicatorsContainer.appendChild(indicator);
        }
      }

      setupEventListeners() {
        this.prevButton.addEventListener('click', () => this.prevSlide());
        this.nextButton.addEventListener('click', () => this.nextSlide());

        this.indicatorsContainer.addEventListener('click', (e) => {
          if (e.target.hasAttribute('data-slide')) {
            this.goToSlide(parseInt(e.target.getAttribute('data-slide')));
          }
        });

        window.addEventListener('resize', () => {
          this.setupCarousel();
          this.updateCarousel();
        });
      }

      prevSlide() {
        const currentSlidesPerView = window.innerWidth <= 768 ? this.slidesPerViewMobile : this.slidesPerView;
        const totalPages = Math.ceil(this.slides.length / currentSlidesPerView);
        this.currentSlide = this.currentSlide > 0 ? this.currentSlide - 1 : totalPages - 1;
        this.updateCarousel();
      }

      nextSlide() {
        const currentSlidesPerView = window.innerWidth <= 768 ? this.slidesPerViewMobile : this.slidesPerView;
        const totalPages = Math.ceil(this.slides.length / currentSlidesPerView);
        this.currentSlide = this.currentSlide < totalPages - 1 ? this.currentSlide + 1 : 0;
        this.updateCarousel();
      }

      goToSlide(slideIndex) {
        this.currentSlide = slideIndex;
        this.updateCarousel();
      }

      updateCarousel() {
        const currentSlidesPerView = window.innerWidth <= 768 ? this.slidesPerViewMobile : this.slidesPerView;
        const slideWidth = 100 / currentSlidesPerView;
        const translateX = -this.currentSlide * 100;

        this.track.style.transform = `translateX(${translateX}%)`;

        const indicators = this.querySelectorAll('.product-highlight-carousel-indicator');
        indicators.forEach((indicator, index) => {
          indicator.classList.toggle('active', index === this.currentSlide);
        });

        const totalPages = Math.ceil(this.slides.length / currentSlidesPerView);
        this.prevButton.disabled = this.currentSlide === 0;
        this.nextButton.disabled = this.currentSlide === totalPages - 1;
      }
    }

    customElements.define('product-carousel', ProductCarousel);
  })();